<template>
	<div class="">
		<div class="back-arrow pl-6 pt-2">
			<router-link to="/discount-bulk">
				<i class="fa fa-fw fa-arrow-left" />
				<span> Back to bulk discounts </span>
			</router-link>
		</div>
		<base-page-heading
			title="Edit Bulk Discount"
			subtitle=""
			class="d-print-none"
		>
			<template #extra>
				<b-button
					ref="btnShow"
					type="submit"
					size="lg"
					variant="secondary"
					@click="updateBulkDiscountProperties"
				>
					Save changes
				</b-button>
			</template>
		</base-page-heading>

		<div class="row">
			<EditBulkDiscountTable
				ref="editbulkdiscount"
				:bulk-discount-id="bulkDiscountId"
			/>
		</div>
	</div>
</template>

<style scoped>
.back-arrow{
	background-color: #f6f7f8;
}
</style>
